import {Action} from "@ngrx/store";
import {IPartner, IPartyRelationShipAttributeValue} from "../../models/partners/partners.interface";

export enum EPartnerActions {
  GetPartners = '[Partners] Get Partners',
  GetPartnersSuccess = '[Partners] Get Partners Success',
  GetPartnersFailure = '[Partners] Get Partners Failure',

  GetPartnerDebtAmount = '[Partners] Get Partner Debt Amount',
  GetPartnerDebtAmountSuccess = '[Partners] Get Partner Debt Amount Success',
  GetPartnerDebtAmountFailure = '[Partners] Get Partner Debt Amount Failure',

  GetPartnerCreditLimitAmount = '[Partners] Get Partner Credit Limit Amount',
  GetPartnerCreditLimitAmountSuccess = '[Partners] Get Partner Credit Limit Amount Success',
  GetPartnerCreditLimitAmountFailure = '[Partners] Get Partner Credit Limit Amount Failure'
}

export class GetPartners implements Action{
  public readonly type = EPartnerActions.GetPartners;
}
export class GetPartnersSuccess implements Action{
  public readonly type = EPartnerActions.GetPartnersSuccess;
  constructor(public payload: Array<IPartner>){}
}
export class GetPartnersFailure implements Action{
  public readonly type = EPartnerActions.GetPartnersFailure;
}


export class GetPartnerDebtAmount implements Action{
  public readonly type = EPartnerActions.GetPartnerDebtAmount;
  constructor(public payload: string){}
}
export class GetPartnerDebtAmountSuccess implements Action{
  public readonly type = EPartnerActions.GetPartnerDebtAmountSuccess;
  constructor(public payload: Array<IPartner>){}
}
export class GetPartnerDebtAmountFailure implements Action{
  public readonly type = EPartnerActions.GetPartnerDebtAmountFailure;
}


export class GetPartnerCreditLimitAmount implements Action{
  public readonly type = EPartnerActions.GetPartnerCreditLimitAmount;
  constructor(public payload: string){}
}
export class GetPartnerCreditLimitAmountSuccess implements Action{
  public readonly type = EPartnerActions.GetPartnerCreditLimitAmountSuccess;
  constructor(public payload: Array<IPartner>){}
}
export class GetPartnerCreditLimitAmountFailure implements Action{
  public readonly type = EPartnerActions.GetPartnerCreditLimitAmountFailure;
}

export type PartnerActions =
  GetPartners |
  GetPartnersSuccess |
  GetPartnersFailure |

  GetPartnerDebtAmount |
  GetPartnerDebtAmountSuccess |
  GetPartnerDebtAmountFailure |

  GetPartnerCreditLimitAmount |
  GetPartnerCreditLimitAmountSuccess |
  GetPartnerCreditLimitAmountFailure;



